module.exports = __webpack_public_path__ + "img/harvard.9df54e84.png";